import { FC, useCallback, useState } from "react";
import { BannerContext } from "./BannerContext";

const BannerProvider: FC = ({ children }) => {
  const [openBanners, setOpenBanners] = useState<string[]>([]);

  const handleAddBannerToOpenBanners = useCallback((bannerName: string) => {
    setOpenBanners((prevBanners) => {
      if (prevBanners.includes(bannerName)) return prevBanners;

      return [bannerName, ...prevBanners];
    });
  }, []);

  const handleRemoveBannerFromOpenBanners = useCallback((bannerName: string) => {
    setOpenBanners((prevBanners) => {
      return prevBanners.filter((banner) => banner !== bannerName);
    });
  }, []);

  return (
    <BannerContext.Provider value={{ openBanners, handleAddBannerToOpenBanners, handleRemoveBannerFromOpenBanners }}>
      {children}
    </BannerContext.Provider>
  );
};

export { BannerProvider };
